import acidIcon from './acidIcon.svg?url';
import adaHubIcon from './adaHubIcon.svg?url';
import airtableIcon from './airtableIcon.svg?url';
import arrowIcon from './arrowIcon.svg?url';
import artistPackIcon from './artistPackIcon.svg?url';
import artistRosterIcon from './artistRosterIcon.svg?url';
import atlanticColorIcon from './atlanticColorIcon.svg?url';
import cobrandIcon from './cobrandIcon.svg?url';
import galleryIcon from './galleryIcon.png?url';
import luminateIcon from './luminateIcon.png?url';
import mondayIcon from './mondayIcon.svg?url';
import opusIcon from './opusIcon.svg?url';
import serviceNowIcon from './serviceNowIcon.svg?url';
import sodatoneIcon from './sodatoneIcon.svg?url';
import songRadarIcon from './songRadarIcon.svg?url';
import sunIcon from './sunIcon.svg?url';
import tableauIcon from './tableauIcon.svg?url';
import warnerBlueIcon from './warnerBlueIcon.svg?url';
import warnerChappellGoldIcon from './warnerChappellGoldIcon.svg?url';
import wavoIcon from './wavoIcon.svg?url';

export type IconType = keyof typeof ICON_BY_TYPE;

export const ICON_BY_TYPE = {
  ACID: acidIcon,
  ADA_HUB: adaHubIcon,
  AIRTABLE: airtableIcon,
  ARROW: arrowIcon,
  ARTIST_PACK: artistPackIcon,
  ARTIST_ROSTER: artistRosterIcon,
  ATLANTIC: atlanticColorIcon,
  CHAPPELL: warnerChappellGoldIcon,
  COBRAND: cobrandIcon,
  GALLERY: galleryIcon,
  LUMINATE: luminateIcon,
  MONDAY: mondayIcon,
  OPUS: opusIcon,
  SERVICE_NOW: serviceNowIcon,
  SODATONE: sodatoneIcon,
  SONG_RADAR: songRadarIcon,
  SUN: sunIcon,
  TABLEAU: tableauIcon,
  WARNER: warnerBlueIcon,
  WAVO: wavoIcon,
} as const;
